export const CALLBACK_QUERY_CODE = 'code';

export const CALLBACK_QUERY_DECISION = 'access_decision';

export const CALLBACK_QUERY_ERROR = 'error';

export const CALLBACK_DECISION_MESSAGES: Readonly<Record<string, string>> = {
  allowed: 'backoffice.auth.callback.decision.allowed',
  onboarding_required: 'backoffice.auth.callback.decision.onboarding_required',
  request_access_required: 'backoffice.auth.callback.decision.request_access_required',
  subscription_action_required: 'backoffice.auth.callback.decision.subscription_action_required',
  blocked: 'backoffice.auth.callback.decision.blocked',
};

export const CALLBACK_DECISION_FALLBACK = 'backoffice.auth.callback.decision.fallback';

export const CALLBACK_ERROR_MESSAGES: Readonly<Record<string, string>> = {
  invalidRequest: 'backoffice.auth.callback.error.invalid_request',
};

export const CALLBACK_ERROR_CODE_MISSING = 'backoffice.auth.callback.error.code_missing';

export const CALLBACK_ERROR_EXCHANGE_FAILED = 'backoffice.auth.callback.error.exchange_failed';

export const CALLBACK_ERROR_NOT_OPERATOR = 'backoffice.auth.callback.error.not_operator';
